import React, { useState, useContext } from "react";
import { apis } from "../apis";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../AuthProvider";
import { KeyRound, ArrowRight } from "lucide-react";
import "./Login.css";

const CheckOTPResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const { login } = useContext(AuthContext);

  const validationSchema = Yup.object({
    otp: Yup.string().required("رمز التحقق مطلوب").length(6, "يجب أن يكون رمز التحقق 6 أرقام"),
  });

  const formik = useFormik({
    initialValues: { otp: "" },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setError("");

      try {
        const response = await apis.checkOtp(email, values.otp);

        if (response.status === "success") {
          localStorage.setItem("token", response.token);
          login(response.token);
          navigate("/reset-password");
        } else {
          setError(response.msg || "فشل في التحقق من رمز OTP.");
        }
      } catch (err) {
        setError("حدث خطأ أثناء التحقق.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h1 className="auth-title">التحقق من رمز OTP</h1>
          <form onSubmit={formik.handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="otp">رمز التحقق</label>
              <div className="input-with-icon">
                <KeyRound size={18} className="input-icon" />
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  placeholder="أدخل رمز التحقق"
                  value={formik.values.otp}
                  onChange={formik.handleChange}
                  className={formik.touched.otp && formik.errors.otp ? "error" : ""}
                />
              </div>
              {formik.touched.otp && formik.errors.otp && (
                <div className="error-message">{formik.errors.otp}</div>
              )}
            </div>
            
            {error && <div className="error-message">{error}</div>}
            
            <button
              type="submit"
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? (
                <span className="loading-spinner"></span>
              ) : (
                <>
                  <span>التحقق</span>
                  <ArrowRight size={18} />
                </>
              )}
            </button>
          </form>
          
          <div className="auth-footer">
            <p>
              لم تستلم الرمز؟{" "}
              <button 
                className="btn-link" 
                onClick={() => navigate("/forgot-password")}
              >
                إعادة الإرسال
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckOTPResetPassword;
